import { QuestionMark } from '@phosphor-icons/react';

export interface HelpProps {
  children?: React.ReactNode;
}

export function Help(props: HelpProps) {
  return (
    <div className="group relative">
      <div className="border border-black rounded-full bgcursor-pointer">
        <QuestionMark size={12} />
      </div>
      <div className="absolute group-hover:block hidden bottom-0 left-full bg-orange-2 text-white z-50 p-1 text-xs break-normal min-w-48">
        {props.children}
      </div>
    </div>
  );
}
